import { useEffect } from 'react'


const LightShow = ({ isActiveWomensMode }) => {
    //const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)


    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")


            // const response = await GetGenderMode()

            // if (response.success) {
            //     setIsActiveWomensMode(response.data.isWomensModeActive)
            // } else {
            //     setIsActiveWomensMode(false)
            // }
        } catch (error) {

        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            {/* Encabezado */}
            {/* <div className='Screen__Start__Background'> */}
                {/* {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='Screen__Welcome__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='Screen__Welcome__Background__Image' />
                )} */}

                {/* {isActiveWomensMode ? (
                    <img src="/img/page/backgrounds/background-womens-day-2026.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
                ) : isActiveWomensMode === false && (
                    <video 
                        src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                        className='SelfieFan__Screen__QR__Background__Video' 
                        autoPlay loop muted playsInline 
                    />
                )} */}
            {/* </div> */}

            {/* Encabezado */}
            <div className='Screen__Start__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='Screen__Welcome__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='Screen__Welcome__Background__Image' />
                )} */}
                {/* <img src='/img/page/backgrounds/background-womens-day-2026.png' className='Screen__Welcome__Background__Image' /> */}

                {/* Atributos vitales para fondos: 
                    autoPlay: inicia solo
                    loop: se repite infinitamente
                    muted: OBLIGATORIO para que los navegadores permitan el autoPlay
                    playsInline: previene que en iOS el video se abra a pantalla completa
                */}

                {/* {isActiveWomensMode ? (
                    <img src="/img/page/backgrounds/background-womens-day-2026.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
                ) : isActiveWomensMode === false && (
                    <video 
                        src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                        className='SelfieFan__Screen__QR__Background__Video' 
                        autoPlay loop muted playsInline 
                    />
                )} */}

                <video 
                    src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    className='SelfieFan__Screen__QR__Background__Video' 
                    autoPlay loop muted playsInline 
                />
            </div>

            {/* Contenido */}
            <section className="Screen__Welcome__Container Container-FullHeight">
                <div className='Screen__Welcome__Container__QR'>
                    {/* <img src="/img/page/qr-inicio-fdm.png" className="Screen__Welcome__Container__QR__Image" alt="Logo" /> */}
                    <img src="/img/page/qr/home-qr-fondo-gris-sin-parametros.png" className="Screen__Welcome__Container__QR__Image" alt="Logo" />
                </div>

                <div className='Screen__Welcome__Container__Info'>
                    {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" /> */}
                    <img src='/img/page/xolo-mayor-show-de-luces.png' style={{ width: '300px', display: 'block', margin: '0 auto' }} />

                    <img src="/img/page/xolos-five.png" className="Screen__Welcome__Container__Info__Image" alt="Logo" />
                    <p className='Screen__Welcome__Container__Text'>Escanea el código</p>
                    <p className='Screen__Welcome__Container__Text'>y únete al</p>
                    <p className='Screen__Welcome__Container__Text'>show de luces</p>
                </div>
            </section>

            {/* Pie de página */}
            <footer className='Screen__Welcome__Footer'>
                <p className='text-center FooterCredits'>Hecho con ♥ por Interaktia | 2026</p>
            </footer>
        </>
    )
}

export { LightShow };